// Helper for any prop that behaves like `as` from styled-components (ie `component` in Button)

/**
 * Compatibility type to include all html attributes with a fix for the `as` prop collision.
 * TODO: improve the type definition for the `css` prop to better mimic styled-components `css` prop definition.
 * https://ghe.spotify.net/encore/web/issues/236
 */

// Compatibility type to include all svg attributes with a fix for the `as` prop collision

export function assertNever(_) {
  throw new Error('Unreachable value');
}

/**
 * Export Foundation tokens
 *
 * TODO: If Foundation merges this PR (https://ghe.spotify.net/encore/foundation/pull/239),
 * remove and re-export from Foundation.
 */

/**
 * Construct a type with the properties of T where T's optional properties (K)
 * are required in the new type.
 */

/**
 * Utility type to make it easy to add documented pseudo state types to components.
 * @example
 * export type ComponentProps = StyledWrapperProps & Pick<PseudoStateProps, 'isHover' | 'isFocus'>;
 * @deprecated
 * These props were meant for internal testing purposes and will be removed soon.
 * For visual regression testing, use the method outlined here instead {@link https://backstage.spotify.net/docs/default/component/encore-web/contributing/storybook/#screendiff Techdocs}
 */

/*
 * Takes a Type and a subset of its properties and prefixes them with a "$"
 * Useful when needing to convert some React component props to be
 * styled-components "transient props"
 * See: https://styled-components.com/docs/api#transient-props
 */

/*
 * Takes a Type and a subset of its properties and prefixes them with a "$" and makes them required
 * Essentially a combination of `Require` and `Prefix$`
 */

/**
 * From Type, pick a set of properties and prefix them with a "$"
 * Essentially a combination of `Pick` and `Prefix$`
 */

/*
 * Takes a type T and tacks on string type while preserving autocomplete
 * Useful when you have a selection of string literals but
 * still want to allow an open string as well
 * See: https://github.com/microsoft/TypeScript/issues/29729
 */

/**
 * Backwards-compatibility type used in components that previously rendered Type and now render Text.
 */